import type { KpiChartsQueryParams } from './kpiDashboardApi';

/**
 * Single selection on the Resilience tab (heatmap cell, priority bar, or assignment group bar).
 * Toggling the same slice clears the filter — same idea as Bandwidth Assignment Group tab drill.
 */
export type KpiResilienceCrossSlice =
  | null
  | {
      kind: 'heatmap';
      weekStart: string;
      isoDow: number;
      weekLabel: string;
      weekdayLabel: string;
    }
  | { kind: 'priority'; label: string }
  | { kind: 'group'; groupName: string };

export function kpiResilienceCrossQueryKey(slice: KpiResilienceCrossSlice): string {
  if (!slice) return 'none';
  if (slice.kind === 'heatmap') return `h:${slice.weekStart}:${slice.isoDow}`;
  if (slice.kind === 'priority') return `p:${slice.label}`;
  return `g:${slice.groupName}`;
}

/** Append GET /dashboard/charts query params for resilience cross-filter. */
export function appendResilienceCrossParams(
  params: KpiChartsQueryParams,
  slice: KpiResilienceCrossSlice
): void {
  if (!slice) return;
  if (slice.kind === 'heatmap') {
    params.resilienceHeatmapWeek = slice.weekStart;
    params.resilienceHeatmapDow = String(slice.isoDow);
  } else if (slice.kind === 'priority') {
    params.resiliencePriority = slice.label;
  } else {
    params.resilienceGroupName = slice.groupName;
  }
}

export function resilienceCrossChipLabel(slice: KpiResilienceCrossSlice): string | null {
  if (!slice) return null;
  if (slice.kind === 'heatmap') return `${slice.weekLabel} · ${slice.weekdayLabel}`;
  if (slice.kind === 'priority') return `Priority: ${slice.label}`;
  return `Assignment group: ${slice.groupName}`;
}
